import * as React from 'react'

function UserIcon(props) {
  return (
    <svg
      width={33}
      height={32}
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.14 16c-3.301 0-5.999-2.687-5.999-5.977C10.141 6.732 12.84 4 16.14 4c3.301 0 5.998 2.687 5.998 5.977 0 3.291-2.697 6.023-5.998 6.023zm9.365 12H6.774a1.34 1.34 0 01-1.338-1.333v-1.334C5.436 22.4 7.844 20 10.787 20h10.704c2.944 0 5.352 2.4 5.352 5.333v1.334A1.34 1.34 0 0125.505 28z"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export { UserIcon }
